import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AuthToken } from '@cobliteam/api-lib';

const useRedirectAfterLogin = () => {
  const location = useLocation();
  const redirectUrl = sessionStorage.getItem('redirectUrl');

  // Save the current URL to redirect back to after login.
  const saveUrlToRedirectAfterLogin = useCallback(() => {
    const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
    if (!redirectUrl && !authToken && location.pathname !== '/login' && location.pathname !== '/password-recovery') {
      const currentLocation = location.pathname + location.search + location.hash;
      sessionStorage.setItem('redirectUrl', currentLocation);
    }
  }, [location.pathname, location.search, location.hash, redirectUrl]);

  const redirectSessionStorage = useCallback(() => {
    if (redirectUrl) {
      sessionStorage.removeItem('redirectUrl');
      return redirectUrl;
    }
    return null;
  }, [redirectUrl]);

  useEffect(() => {
    saveUrlToRedirectAfterLogin();
  }, [saveUrlToRedirectAfterLogin]);

  return {
    saveUrlToRedirectAfterLogin,
    redirectSessionStorage,
  };
};

export default useRedirectAfterLogin;
